import {
  LOADING_TURNOS,
  GET_TURNOS_SUCCESS,
  GET_TURNOS_FAILURE,
  SET_TURNOS_PAGE,
  RESET_TURNOS
} from "../actions/types/turnos";

const initialState = {
  turnos: [],
  loading: true,
  links: {
    first: null,
    last: null,
    next: null,
    prev: null
  },
  meta: {
    currentPage: 1,
    from: null,
    to: null,
    total: null
  },
  filters: {
    page: 0
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_TURNOS: {
      return {
        ...state,
        loading: true
      };
    }

    case GET_TURNOS_SUCCESS: {
      return {
        ...state,
        loading: false,
        turnos: [...action.payload.turnos],
        links: {
          ...state.links,
          first: action.payload.links.first,
          last: action.payload.links.last,
          next: action.payload.links.next,
          prev: action.payload.links.prev
        },
        meta: {
          ...state.meta,
          currentPage: action.payload.meta.currentPage,
          from: action.payload.meta.from,
          to: action.payload.meta.to,
          total: action.payload.meta.total
        }
      };
    }

    case GET_TURNOS_FAILURE: {
      return {
        ...state,
        loading: false
      };
    }

    case SET_TURNOS_PAGE: {
      return {
        ...state,
        loading: false,
        meta: {
          ...state.meta,
          currentPage: action.payload.page
        },
        filters: {
          ...state.filters,
          page: action.payload.page
        }
      };
    }

    case RESET_TURNOS: {
      return {
        ...state,
        ...initialState
      };
    }

    default: {
      return state;
    }
  }
};
